import { createSelector } from '@ngrx/store';
import { selectBasicDataState } from './main.selector';
import { IBasicDataState } from '../reducers';
import { IConfigBasicData } from '@shared/model/basic-data';

export const selectConfig = createSelector(
  selectBasicDataState,
  (basicDataState: IBasicDataState) => basicDataState.config,
);

export const selectBasicDataConfig = createSelector(selectConfig, (config: IConfigBasicData) => config);
